import { useListenWorkoutQuery } from '../programApi'

export function MultiWktDragOverlay(props) {
  const { multiWktDragging, orgId } = props
  const { id: workoutId, wktIdx } = multiWktDragging

  const { data: workout = {} } = useListenWorkoutQuery({
    orgId,
    workoutId,
  })

  return (
    <div className='flex flex-col ring-1 p-4 ring-gray-200 bg-white shadow-xl rounded-lg overflow-hidden'>
      <h4 className='capitalize font-medium text-sm truncate'>
        <span className='mr-1 whitespace-nowrap'>{wktIdx + 1}.</span>
        <span className='truncate ml-1'>{workout?.title || 'Untitled workout'}</span>
      </h4>
    </div>
  )
}
